import { useViewerLocale } from "@/lib/translator";
import formatPrice from "@/lib/utils/format-price";

type UseFormatPriceOptions = {
  amount: number;
  currency: string;
};

export default function useFormatPrice() {
  const locale = useViewerLocale();
  return ({
    amount,
    currency,
  }: UseFormatPriceOptions) => formatPrice({amount, currency, locale});
}
